import axios from '@/libs/api.request'
export const getLabel = (params) => {
  return axios.request({
    url: '/common/label',
    method: 'GET',
    params
  })
}
export const getDetails = (id) => {
  return axios.request({
    url: `/common/label/${id}`,
    method: 'GET'
  })
}
export const del = (id) => {
  return axios.request({
    url: `/common/label/${id}`,
    method: 'DELETE'
  })
}
export const update = (data) => {
  return axios.request({
    url: `/common/label/${data.id}`,
    method: 'PUT',
    data
  })
}
export const add = (data) => {
  return axios.request({
    url: '/common/label',
    method: 'POST',
    data
  })
}
